import { useQuery } from 'urql'
import { GeneralServiceOrderByColumn, GeneralServiceOrderByClause, GeneralServicesFilterInput, SortOrder } from 'gql/graphql'
import { graphql } from 'gql'
import ServiceSliderSection from '../ServiceSliderSection'
import { ServiceSliderProps } from '../ServiceSlider'

interface ServiceCarouselSectionProps extends ServiceSliderProps {
  filters?: GeneralServicesFilterInput
  orderBy?: GeneralServiceOrderByClause[]
}

const ServiceCarouselSection = ({
  className = {
    container: 'my-75 lg:my-[175px]',
  },
  filters,
  orderBy = [{
    column: GeneralServiceOrderByColumn.Random,
    order: SortOrder.Asc,
  }],
  ...props
}: ServiceCarouselSectionProps) => {
  const [{ data, fetching }] = useQuery({
    query: graphql(`
      query ServiceCarouselSection(
        $filters: GeneralServicesFilterInput,
        $orderBy: [GeneralServiceOrderByClause!]
      ) {
        services(first: 9, filters: $filters, orderBy: $orderBy) {
          data {
            id
            title
            slug
            survey_slug
            description
            service_image {
              id
              url
            }
            image_alt_text
            form_link
          }
        }
      }
    `),
    variables: {
      filters: filters,
      orderBy: orderBy,
    },
  })

  if (fetching || (data?.services.data ?? []).length === 0) {
    return null
  }

  return (
    <ServiceSliderSection
      data={data}
      fetching={fetching}
      {...props}
      className={className}
    />
  )
}

export default ServiceCarouselSection
